/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-unused-vars */
import React from 'react';
import { CDN } from '../../../../constants';

export default function RelatedDocuments({ OrderDetails }) {
    return (
        OrderDetails?.po_document.length > 0 ? (
            <div className="border border-[#CBC7C7 rounded-md bg-[#F5F5FA] h-auto p-3 my-4">
                <p className="font-semibold text-base text-[#090406]">Related Documents</p>
                {OrderDetails?.po_document.length > 0 && OrderDetails?.po_document?.map((item) => (
                    <div className="flex items-center flex-wrap">
                        <img src="/images/doc.svg" alt="icon" />
                        <p className="ml-2 mr-3 font-normal text-base text-black">PO Document</p>
                        <p className="font-semibold text-sm text-[#000000] ml-1.5 break-words">{item?.split('/')?.at(-1)}</p>
                        <div className="flex items-center ml-4">
                            <img src="/images/download.svg" alt="icon" className="cursor-pointer" />
                            <p
                                className="text-[#5B5B5B] text-xs3 font-semibold ml-1 cursor-pointer"
                                onClick={() => {
                                    window.open(`${CDN}/${item}`, '_blank');
                                }}
                            >
                                Download

                            </p>
                        </div>
                    </div>
                ))}
            </div>
        ) : null
    );
}
